import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/salesCategories/:id',
  title: 'title.show',
  endpoint: '/app/purchase_category',
  breadcrumbs: [],
}
